module.exports = __webpack_public_path__ + "img/logo.3bbfabd8.png";